import { combineReducers, configureStore } from '@reduxjs/toolkit';

import appSlice from './appSlice';
import dialogsSlice from './dialogsSlice';
import shipFeaturesSlice from './shipFeaturesSlice';
import wowsCommerceSlice from './wowsCommerceSlice';

import type { ThunkAction } from 'redux-thunk';
import type { Action } from 'redux';

import dialogListenerMiddleware from '~/middleware/dialogListenerMiddleware';

const reducers = {
    app: appSlice,
    dialogs: dialogsSlice,
    shipFeatures: shipFeaturesSlice,
    wowsCommerce: wowsCommerceSlice,
};

const store = configureStore({
    reducer: combineReducers(reducers),
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware({
            // wowsCommerce's products are not serializable
            serializableCheck: {
                ignoredPaths: [
                    'wowsCommerce.products',
                ],
                ignoredActions: [
                    'wowsCommerce/loadProducts/fulfilled',
                ],
            },
        }).prepend(dialogListenerMiddleware);
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type Thunk = ThunkAction<void, RootState, unknown, Action>;

window.store = store;

export default store;
